import { useState, useContext, useEffect } from "react";
import { useDeviceInfo } from '../../hooks/useUserAgent';
import AuthenticationService from "../../services/AuthService";
import Cs from "../../services/CommonService";
import { useMenuItemProps } from '../SideMenu/useMenuItemProps';
import PageUISettings from './PageUISettings';
import { CacheContext } from "../../contexts/Cache/CacheStateProvider";

const useAuth = (history, userDispatch, geoData) => {
	const {getDeviceInfo} = useDeviceInfo();
	const {sideMenuRoute} = useMenuItemProps();

	const {cacheState, cacheDispatch} = useContext(CacheContext);

  let [user, setUser] = useState({
    registration_mode: '',
    email: '',
    password: '',
    isSubmitting: false,
    errorMessage: null
  });
  let [activePageUISetting, setActivePageUISetting] = useState(null);

  useEffect(() => {
    setActivePageUISetting(cacheState?.activeUISetting ?? null);
  }, [cacheState]);

	const handleFormSubmit = async (e) => {
	    e && e.preventDefault();
	    const userAgent = Cs.getBrowserType();
	    setUser({
	      ...user,
	      isSubmitting: true,
	      errorMessage: null
	    })
	    /*if (user.isChecked) {
	      localStorage.email = user.email
	      localStorage.password = user.password
	      localStorage.checkbox = true
	    }*/
	    const req = { 
	      'user': { 
	        'email': user.email, 
	        'password': user.password,
	        'phone_no': user.phone_no,
	        'uid': user.uid,
	        'registration_mode': user.registration_mode,
	        'geo_data': geoData.geo_data,
	        'user_agent': userAgent,
	        'token': user.token,
	        'platform': navigator.platform, 
	        'lrid': localStorage.cuedlink_uid,
	        'device': await getDeviceInfo()
	      } 
	    }
	    AuthenticationService.signin(req).then((res) => {
	      if ([201, 200].includes(res.status)) {  
	        userDispatch({
	          type: "LOGIN",
	          payload: res.data,
	        })
	        localStorage.setItem("authorization", res.data.token); //added due to safari cors issue
	        /*if(env.admin_emails.includes(res.data.user.email)){
	        	//if(userAgent !== 'Safari')
	        	//PushNotification(res.data.user);
	        }*/
	      } else {
	      	if(user.registration_mode === 'uid'){
	      		history.push('/signin');
	      	}else{
		      	setUser({
		          ...user,
		          isSubmitting: false,
		          errorMessage: res.data.error || res.statusText,
		        });
	      	}
	      }
	    }).catch((error) => {
	      console.log('error',error);
	      setUser({ ...user, isSubmitting: false, errorMessage: 'Network Error' });
	    })
  	}

	const routeUser = (user) => {
	    if(user.is_active == false && user.in_active_reason == "default_password_not_reset"){
	        history.push("/password/update");
	    }else if(user.current_member?.home_page?.sid){
	    	sideMenuRoute();
	    }
		/*else if(user.setting?.welcome_tour !== 'Completed'){
	      history.push('/journey/tour');
	    }*/
	    else{
	     	history.push("/ecn/table");
	    }
	}

  return {
    user,
    setUser,
    handleFormSubmit,
    routeUser,
    activePageUISetting,
  };
};

export default useAuth;